import React, { useState } from 'react'
import { getTrackBackground, Range } from 'react-range'
import { useCurrentLocale } from '../src/contexts/CurrentLanguageContext'

export interface IntervalSliderProps {
	min: number
	max: number
	currentMin: number
	currentMax: number
	onChange: (min: number, max: number) => void
	currency?: 'EUR' | 'CZK'
	suffix?: string
}

export const IntervalSlider: React.FunctionComponent<IntervalSliderProps> = ({
	min,
	max,
	currentMin,
	currentMax,
	onChange,
	currency,
	suffix,
}) => {
	const locale = useCurrentLocale()
	const [values, setValues] = useState([currentMin, currentMax])
	const [interactiveMin, interactiveMax] = values

	const formatNumber = React.useCallback(
		(value: number) => {
			let formattedNumber = new Intl.NumberFormat(
				locale,
				currency
					? {
							currency,
							style: 'currency',
					  }
					: undefined,
			).format(currency ? value / 100 : value)
			if (suffix) {
				formattedNumber += suffix
			}
			return formattedNumber
		},
		[locale, currency, suffix],
	)

	return (
		<div className="intervalSlider">
			<div className="intervalSlider-selected">
				Od:{' '}
				<span className="intervalSlider-selected-value">
					{formatNumber(interactiveMin)}
				</span>{' '}
				do:{' '}
				<span className="intervalSlider-selected-value">
					{formatNumber(interactiveMax)}
				</span>
			</div>
			<Range
				min={min}
				max={max}
				step={1}
				values={values}
				onChange={setValues}
				onFinalChange={(values) => onChange(values[0], values[1])}
				renderTrack={({ props, children }) => (
					<div
						{...props}
						className="intervalSlider-track"
						style={{
							...props.style,
							backgroundImage: getTrackBackground({
								values: values,
								colors: ['rgba(0,0,0,0)', '#9DCAAA', 'rgba(0,0,0,0)'],
								min,
								max,
							}),
						}}
					>
						{children}
					</div>
				)}
				renderThumb={({ props }) => (
					<div
						{...props}
						className="intervalSlider-thumb"
						style={{
							...props.style,
						}}
					/>
				)}
			/>
		</div>
	)
}
